import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef } from '@angular/core';
import { Http, ResponseContentType, Headers } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import {
    DropzoneComponent, DropzoneDirective,
    DropzoneConfigInterface
} from 'ngx-dropzone-wrapper';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import { environment } from '../../../../../../environments/environment';
import {
    ScriptLoaderService, ClassService
} from './../../../../../_services';
import {
    Investor, InvestorMonthlyCut, InvestorMonthlyCutProviders, INVESTOR_INCLUDES
} from '../../../../../_models';
import {
    Statement, Invoice
} from '../../../../../_models/Classes';

import { ModalComponent } from '../../../../../shared/modal';
import { UnitTableComponent } from '../../units/unit-table';

@Component({
    selector: 'app-investor-detail',
    templateUrl: './investor-detail.component.html',
    styleUrls: ['./investor-detail.component.scss'],
    providers: [InvestorMonthlyCutProviders]
})
export class InvestorDetailComponent implements OnInit, AfterViewInit {
    investement: number;
    investorId: any;
    currentUser = JSON.parse(localStorage.getItem('currentUser')) || { "token": "" };
    selectedType: any;
    selectedContact: any;
    header = {
        icon: '',
        text: ''
    };
    static initialClass: string =
    'm-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default';
    public config: DropzoneConfigInterface = {
        clickable: true,
        maxFiles: 1,
        maxFilesize: 50,
        autoReset: null,
        errorReset: null,
        cancelReset: null,
        acceptedFiles: '',
        autoProcessQueue: false,
        createImageThumbnails: false,
        addRemoveLinks: true,
        dictRemoveFile: 'Eliminar archivo',
        dictDefaultMessage: 'Selecciona el archivo',
        headers: { Authorization: `Bearer ${this.currentUser.token}` },
        paramName: 'file'
    };

    fileIndicationLabel: string = '';
    fileMaxSizeLabel: string = `(Máximo: ${this.config.maxFilesize}MB) `;
    @ViewChild(DropzoneComponent) componentRef: DropzoneComponent;
    @ViewChild(DropzoneDirective) directiveRef: DropzoneDirective;

    @ViewChild('uploadSuccesSwal') private uploadSuccesSwal: SwalComponent;
    @ViewChild('addressQuestionSwal') private addressQuestionSwal: SwalComponent;

    @BlockUI('file-list') blockUIFileList: NgBlockUI;

    @ViewChild(ModalComponent) modal: ModalComponent;
    @ViewChild(UnitTableComponent) unitTable: UnitTableComponent;


    documentTypes = [];
    dataFetched: boolean = false;
    params = '';
    investor = this.data.make({});
    fileEndpoint = environment.fileEndpoint;
    constructor(private _script: ScriptLoaderService, private _classService: ClassService,
        private route: ActivatedRoute,
        private _sanitizer: DomSanitizer,
        private data: Investor,
        private monthlyCuts: InvestorMonthlyCut
    ) {
        data.sanitizer = _sanitizer;
    }

    ngOnInit() {
        this.investorId = this.route.snapshot.params['id'];

        this.config.url = environment.devApiEndpoint + '/file/' + this.investorId;
        this.dataFetched = false;
        this.data.get(this.investorId, `include=${INVESTOR_INCLUDES},units`).subscribe(investor => {
            this.investor = investor;
            this.header.text = `Propietario ${investor.name || '-'}`;
            this.dataFetched = true;
        }, err => {
            console.error(err);
        }, () => {
            this.getContacts();
            this.monthlyCuts.getInvestorMonthlyCuts(this.investorId, 'include=invoice,statement')
                .subscribe(monthlyCuts => { });
            this.getInvestorDocuments(this.investor);
            this.unitTable
                .getData(`investor_id=${this.investorId}&include=investor,property`).subscribe(units => { });
        });
    }
    getContacts() {
        this.data.getContacts(this.investorId).subscribe(contacts => { });
    }
    ngAfterViewInit() {
        this._script.loadScripts('app-index',
            ['assets/app/js/investor.js']);
        this._classService.setClass(document.body, InvestorDetailComponent.initialClass);
    }

    copyAddress() {
        this.data.copyFiscalAddress(this.investorId).subscribe(response => {
            this.data.getAddress(this.investorId).subscribe(address => { });
        });
    }

    upload() {
        this.directiveRef.dropzone().processQueue();
    }

    onUploadSuccess() {
        this.directiveRef.reset();
        this.getInvestorFiles();
        this.uploadSuccesSwal.show();
    }

    deleteInvestorFile(file) {
        let docIndex = this.data.findWithAttr(this.documentTypes, 'name', file.type);
        if (docIndex != -1)
            this.documentTypes[docIndex].doc = null;
        this.data.deleteFile(this.investorId, file.id).subscribe(response => { });
    }
    onUploadError(event: any) {
        console.error(event);
    }
    getInvestorFiles() {
        this.data.getFiles(this.investorId).subscribe(files => {
            this.documentTypes.forEach((docType: any) => {
                let docIndex = this.data.findWithAttr(files, 'type', docType.name);
                if (docIndex != -1)
                    docType.doc = files[docIndex];
            });
        });
    }
    getInvestorDocuments(investor) {
        this.data
            .getDocumentsToAsk(`people_types=${investor.type}&apply_foreign=${investor.is_foreign}`)
            .subscribe(data => {
                this.documentTypes = data;
                this.selectedType = this.documentTypes[0];
                this.acceptedFilesChange(this.selectedType);
                this.getInvestorFiles();
            });
    }

    view(file) {
        if (file instanceof Statement) {
            // Show statement or invoice
            let investorFile = file.toInvestorFile();
            investorFile.data = `${environment.fileEndpoint}/${investorFile.data}`;
            this.data.file = this.data.trustFile(investorFile);
        }
        else {
            this.data.file = file;
        }
        this.modal.show();
    }

    acceptedFilesChange(doc: any) {
        if (doc) this.config.acceptedFiles = doc.file_types;
        this.fileIndicationLabel = `${this.config.acceptedFiles} ${this.fileMaxSizeLabel}`;
    }

    ceil(data: number) {
        return Math.ceil(data);
    }

    tabChanged(tab) {
        switch (tab.id) {
            case 'documentacion':
                if (!this.documentTypes.length) this.getInvestorDocuments(this.investor);
                break;
        }
    }
    deleteContact(contactId) {
        this.data.deleteContact(this.investorId, contactId).subscribe(data => {
            this.getContacts();
        });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/investor/investor-detail/investor-detail.component.ts